export const API_URL = "https://sistema.playmovel.com.br/api/"
export const API_TOKEN = "ce5f11566c56cdc50d089ad322e9a77906f2ba6b5cd910b09e" 